import {
  TrueFalseNodeData,
  MediaData,
  NumberMediaData,
  TrueFalseData,
} from '../../../types/quiz';
import { getQuestion, parseMainExp } from './utils';

/**
 * GetQuestion.
 */
export const mapTrueFalseData = ({
  data,
  mediaData,
}: {
  data: TrueFalseNodeData;
  mediaData: MediaData<NumberMediaData[]>;
}): TrueFalseData => {
  return {
    question: getQuestion(data.q, mediaData),
    answers: [
      {
        isCorrect: data.a === 't',
        text: 'True',
        explanation: parseMainExp(data.e, mediaData) || '',
      },
      {
        isCorrect: data.a === 'f',
        text: 'False',
        explanation: parseMainExp(data.e, mediaData) || '',
      },
    ],
  };
};
